export var map = null;

export const mapSetters = {
  map(m) {
    map = m;
  }
};
